"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Modal = require("@ccw-pwa-ui/Modal");
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
var _Header = require("@ccw-pwa-ui/Header");
var _Dropdown = require("@ccw-pwa-ui/Dropdown");
require("../styles/ContactPentairComponent.css");
var _reactBootstrap = require("react-bootstrap");
var _Button = require("@ccw-pwa-ui/Button");
const ContactPentairComponent = props => {
  var _props$modalDropdownD, _props$modalDropdownD2, _props$modalDropdownD3, _props$modalDropdownD4, _props$modalDropdownD5, _props$modalDropdownD6, _props$modalDropdownD7, _props$modalDropdownD8, _props$modalDropdownD9, _props$modalDropdownD10, _props$modalDropdownD11, _props$modalDropdownD12, _props$modalDropdownD13;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "contact-pentair-screen"
  }, props.isHeaderVisible ? /*#__PURE__*/_react.default.createElement(_Header.Header, {
    imageUrl: props.headerImage,
    imageStyle: {
      height: 30,
      maxWidth: 100
    }
  }) : null, ((_props$modalDropdownD = props.modalDropdownData) === null || _props$modalDropdownD === void 0 ? void 0 : _props$modalDropdownD.displayModal) && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    displayModal: (_props$modalDropdownD2 = props.modalDropdownData) === null || _props$modalDropdownD2 === void 0 ? void 0 : _props$modalDropdownD2.displayModal,
    modalHeaderText: (_props$modalDropdownD3 = props.modalDropdownData) === null || _props$modalDropdownD3 === void 0 ? void 0 : _props$modalDropdownD3.modalHeaderText,
    modalHeaderTextStyle: (_props$modalDropdownD4 = props.modalDropdownData) === null || _props$modalDropdownD4 === void 0 ? void 0 : _props$modalDropdownD4.modalHeaderTextStyle,
    modalDetailText: (_props$modalDropdownD5 = props.modalDropdownData) === null || _props$modalDropdownD5 === void 0 ? void 0 : _props$modalDropdownD5.modalDetailText,
    modalHeaderIcon: (_props$modalDropdownD6 = props.modalDropdownData) === null || _props$modalDropdownD6 === void 0 ? void 0 : _props$modalDropdownD6.modalHeaderIcon,
    displayCrossIcon: (_props$modalDropdownD7 = props.modalDropdownData) === null || _props$modalDropdownD7 === void 0 ? void 0 : _props$modalDropdownD7.displayCrossIcon,
    variant: (_props$modalDropdownD8 = props.modalDropdownData) === null || _props$modalDropdownD8 === void 0 ? void 0 : _props$modalDropdownD8.variant,
    positiveActionButtonTitle: (_props$modalDropdownD9 = props.modalDropdownData) === null || _props$modalDropdownD9 === void 0 ? void 0 : _props$modalDropdownD9.positiveActionButtonTitle,
    positiveAction: (_props$modalDropdownD10 = props.modalDropdownData) === null || _props$modalDropdownD10 === void 0 ? void 0 : _props$modalDropdownD10.positiveAction,
    negativeButtonActionTitle: (_props$modalDropdownD11 = props.modalDropdownData) === null || _props$modalDropdownD11 === void 0 ? void 0 : _props$modalDropdownD11.negativeButtonActionTitle,
    crossIconAction: (_props$modalDropdownD12 = props.modalDropdownData) === null || _props$modalDropdownD12 === void 0 ? void 0 : _props$modalDropdownD12.crossIconAction,
    negativeAvtion: (_props$modalDropdownD13 = props.modalDropdownData) === null || _props$modalDropdownD13 === void 0 ? void 0 : _props$modalDropdownD13.negativeAvtion
  })), props.onContactPentair && /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    displayModal: props.onContactPentair,
    contactPentair: props.contact,
    onClickSupport: props.onClickSupport,
    BlueTick: props.BlueTick,
    wrapperStyle: props.wrapperStyle,
    selectedCategory: props.selectedCategory
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, {
    className: "contact-pentair-container"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "contact-pentair-screen-title"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    variant: "link-text",
    headerText: props.headerText
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginBottom: 30
    }
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400
    },
    variant: "header-text",
    headerText: props.headerSubText
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "contact-pentair-input-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333',
      marginBottom: '20px'
    },
    variant: "header-text",
    headerText: "Select Category"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown-mobile-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown-wrapper",
    onClick: props.modalClick,
    "data-testid": "mobile-modal"
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      color: '#333333',
      fontSize: '16px'
    }
  }, " ", props.selectedCategory), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      marginRight: '8px'
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: props.downwardArrow,
    alt: "right"
  }))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "dropDown-desktop-view",
    "data-testid": "dropDown-desktop"
  }, /*#__PURE__*/_react.default.createElement(_Dropdown.Dropdown, {
    key: 'simple-text',
    dropdownList: props.categoryDropDownList,
    selectedItem: props.selectedCategoryDesktop.title,
    itemClick: props.selectingCategory
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "text-area-container"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      color: '#333333'
    },
    variant: "header-text",
    headerText: props.firstNameText
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "text-area"
  }, /*#__PURE__*/_react.default.createElement("textarea", {
    id: "textarea",
    placeholder: "Write a Message",
    onChange: props.onChangeSupportMessage,
    style: {
      borderRadius: '10px',
      borderColor: "#EBEBEB",
      padding: "10px",
      height: "150px",
      width: "100%",
      outline: "none",
      borderWidth: '2px'
    }
  }, props.supportMessage)))), /*#__PURE__*/_react.default.createElement("div", {
    className: "contact-pentair-button-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "contact-pentair-button-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "primary-long",
    title: props.sendButton,
    onClick: props.onClickSend,
    disabled: !props.onClickSendDisabled
  }))))), props.isLoading ? /*#__PURE__*/_react.default.createElement("div", {
    className: "spinner-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Spinner, {
    animation: "border"
  })) : null);
};
var _default = exports.default = ContactPentairComponent;